import React from 'react';

const ModalPage = ({ 
  title, 
  children, 
  onClose, 
  loading = false, 
  error = null, 
  notFound = false,
  showPrintButton = true 
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  if (loading) {
    return (
      <div className="modal show d-block modal-overlay-dark" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-fullscreen" role="document">
          <div className="modal-content enhanced-briefing-modal">
            <div className="modal-header">
              <h1 className="modal-title">Loading {title}</h1>
              <button 
                type="button" 
                className="modal-close-button" 
                onClick={handleClose}
                aria-label="Close"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="briefing-content">
                <div className="modal-loading">
                  <div className="loading-spinner">
                    <i className="fas fa-spinner fa-spin fa-2x"></i>
                  </div>
                  <p>Loading {title.toLowerCase()}...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modal show d-block modal-overlay-dark" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-fullscreen" role="document">
          <div className="modal-content enhanced-briefing-modal">
            <div className="modal-header">
              <h1 className="modal-title">Error Loading {title}</h1>
              <button 
                type="button" 
                className="modal-close-button" 
                onClick={handleClose}
                aria-label="Close"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="briefing-content">
                <div className="alert alert-danger">
                  <h4>Error Loading {title}</h4>
                  <p>{error}</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleClose}>
                Return to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="modal show d-block modal-overlay-dark" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-fullscreen" role="document">
          <div className="modal-content enhanced-briefing-modal">
            <div className="modal-header">
              <h1 className="modal-title">{title} Not Found</h1>
              <button 
                type="button" 
                className="modal-close-button" 
                onClick={handleClose}
                aria-label="Close"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="briefing-content">
                <div className="alert alert-warning">
                  <h4>{title} Not Found</h4>
                  <p>The requested {title.toLowerCase()} could not be found.</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleClose}>
                Return to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal show d-block modal-overlay-dark" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-fullscreen" role="document">
        <div className="modal-content enhanced-briefing-modal">
          <div className="modal-header">
            <h1 className="modal-title">{title}</h1>
            <button 
              type="button" 
              className="modal-close-button" 
              onClick={handleClose}
              aria-label="Close"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="briefing-content">
              {children}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>
              Close
            </button>
            {showPrintButton && (
              <button 
                type="button" 
                className="btn btn-success"
                onClick={() => window.print()}
              >
                <i className="fas fa-print me-2"></i>
                Print
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPage;